import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TabSdk } from '@techextensor/tab-sdk';
import { StorageConstants } from '@techextensor/tab-core-utility';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  let headers = req.headers;

  // Check if the request contains a custom header marker
  const skipInterceptor = req.headers.get('X-Skip-Interceptor');

  if (!skipInterceptor) {
    // temp patch
    headers = headers.append('Content-Type', 'application/json');
    if(TabSdk.store.token){
      headers = headers.set(StorageConstants.Authorization, TabSdk.store.token);

    } else if(TabSdk.store.staticToken && !TabSdk.store.token) {
      headers = headers.set(StorageConstants.Authorization, TabSdk.store.staticToken);

    }
    headers = headers.set(StorageConstants.applicationCode, TabSdk.store.appName ?? environment.commonConfig.applicationCode);
    headers = headers.set(StorageConstants.TenantId, TabSdk.store.tenantId ?? environment.commonConfig.tenantId);
    headers = headers.set(StorageConstants.AppId, TabSdk.store.appId ?? environment.commonConfig.applicationId);
    headers = headers.set(StorageConstants.EnvironmentId, TabSdk.store.environmentId ?? environment.id);

  } else {
    // Remove the custom header marker
    headers = headers.delete('X-Skip-Interceptor');
  }

  const newReq = req.clone({ headers });

  return next(newReq);
};